import { Button } from '@mui/material';
import { useToggleButtonStyles } from './toggle-button.styles';

export type ToggleButtonColor = 'secondary' | 'primary';

export function ToggleButton({
  color,
  isSelected,
  label,
  fullWidthOnMobile,
  onClick
}: {
  label: string;
  isSelected: boolean;
  color: ToggleButtonColor;
  fullWidthOnMobile?: boolean;
  onClick(): void;
}) {
  const classes = useToggleButtonStyles({ fullWidthOnMobile });
  return (
    <Button
      variant="outlined"
      classes={{ root: `${classes.root} ${classes.label}`, outlined: isSelected ? undefined : classes.idle }}
      color={color}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
